if (!customElements.get("pant-colour-picker")) {
  customElements.define("pant-colour-picker", class PantColourPicker extends HTMLElement {
    static storageKey = "surma:pant-colour-selection";

    connectedCallback() {
      this.label = this.querySelector("[data-pant-colour-label]");
      this.error = this.querySelector("[data-pant-colour-error]");
      this.options = [...this.querySelectorAll("[data-pant-product-id]")];
      this.boundOptionClick = (event) => {
        const option = event.target.closest("[data-pant-product-id]");
        if (!option || !this.contains(option)) return;
        if (option.dataset.pantProductId === this.dataset.productId) {
          event.preventDefault();
          this.selectOption(option);
          return;
        }
        this.rememberSelection(option);
      };
      this.addEventListener("click", this.boundOptionClick);
      this.restoreSelectionAfterNavigation();

      this.boundSubmit = (event) => {
        const formId = event.target?.id || "";
        if (formId === `product-form-${this.dataset.sectionId}` || formId === `sticky-atc-form-${this.dataset.sectionId}`) {
          this.validate(event);
        }
      };
      this.boundCartAction = (event) => {
        const button = event.target.closest('[name="add"], [data-set-modal-add-to-cart]');
        if (button && this.isCartActionForSection(button)) this.validate(event);
      };
      document.addEventListener("submit", this.boundSubmit, true);
      document.addEventListener("click", this.boundCartAction, true);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.boundOptionClick);
      document.removeEventListener("submit", this.boundSubmit, true);
      document.removeEventListener("click", this.boundCartAction, true);
    }

    rememberSelection(option) {
      try {
        sessionStorage.setItem(PantColourPicker.storageKey, JSON.stringify({
          productId: option.dataset.pantProductId,
          colourName: option.dataset.colourName,
        }));
      } catch (_) {}
    }

    restoreSelectionAfterNavigation() {
      let selection = null;
      try {
        selection = JSON.parse(sessionStorage.getItem(PantColourPicker.storageKey));
        sessionStorage.removeItem(PantColourPicker.storageKey);
      } catch (_) {}
      if (!selection || `${selection.productId}` !== `${this.dataset.productId}`) return;

      const selectedOption = this.options.find((option) => option.dataset.pantProductId === `${selection.productId}`);
      if (!selectedOption) return;
      this.selectOption(selectedOption);
    }

    selectOption(option) {
      option.classList.add("is-selected");
      option.setAttribute("aria-current", "page");
      this.label.textContent = option.dataset.colourName ? ` ${option.dataset.colourName}` : "";
      this.dataset.hasSelection = "true";
      this.error.hidden = true;
    }

    validate(event) {
      if (this.dataset.hasSelection === "true") return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.error.hidden = false;
      this.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    isCartActionForSection(button) {
      const productInfo = button.closest("product-info");
      if (productInfo?.dataset.sectionId === this.dataset.sectionId) return true;

      const stickyAtc = button.closest('[id^="Sticky-Addtocart-"]');
      if (stickyAtc?.id === `Sticky-Addtocart-${this.dataset.sectionId}`) return true;

      const setPicker = button.closest("product-set-picker");
      return setPicker?.dataset.sectionId === this.dataset.sectionId;
    }
  });
}
